import React, { useEffect, useState } from "react";
import "./chekin.scss";
import Table from "react-bootstrap/Table";
import refreshIcon from "../../../assets/icon-white/refresh-white.svg";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import moment from "moment";
import ReactPaginate from "react-paginate";
import ModalUmum from "../../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";
import dateFormat from "dateformat";
import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import { useRef } from "react";
import lodash, { parseInt } from 'lodash'
import SweetAlert from "react-bootstrap-sweetalert";
import Button from 'react-bootstrap/Button';
import * as Icon from "react-feather"
import { ImSpoonKnife } from "react-icons/im";

function Chekin() {
  const [data, setData] = useState([]);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [aktifGuest, setAktifGuest] = useState();
  const [showModalPrice, setShowModalPrice] = useState(false)
  const [showModalKey, setShowModalKey] = useState(false)
  const [successEditModalPrice, setSuccessEditShowModalPrice] = useState(false)
  const [idForPrice, setIdForPrice] = useState()
  const [price, setPrice] = useState()
  const [key, setKey] = useState()

  let componentRef = useRef();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/checkin");
    const name = result?.data?.data?.map((value) => value?.name?.toLowerCase());
    const key = result?.data?.data?.map((value) => value?.key?.toString());
    setData(result.data.data);
    setAutoComplete(lodash.uniq(name.concat(key)));
    setGetSuccess(true);
    autoDelete(result.data.data);
    handleAktifGuest(result.data.data);
  };

  //atomatis delete
  const autoDelete = (data) => {
    const d = new Date();
    data &&
      data.forEach(async (item) => {
        if (item.out !== null) {
          if (
            dateFormat(new Date(item.out), "d-mm-yyyy") !==
            dateFormat(d, "d-mm-yyyy")
          ) {
            await axios.delete(`https://mobile.amospa.com/checkin/${item.id}`);
          }
        }
      });
  };

  const handleAktifGuest = (data) => {
    let result = [];
    data.forEach((item) => {
      if (item.out === null) {
        result.push(item);
      }
      setAktifGuest(result);
    });
  };

  //handle checkout
  const handleCheckout = async (id) => {
    await axios.put(`https://mobile.amospa.com/checkin/${id}`, {
      out: new Date(),
      mode: "Checkout",
    });
    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
  };

  //Handle search
  const keys = ["name", "key"];
  const handleSearch = () => {
      return search
      ? data.filter((item) =>keys.some((key) => item[key].toString().toLowerCase().includes(search)))
      : false;
  };

  const member = handleSearch();
  const dataTable = member ? member : currentItems;

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  //Header csv
  const headers = [
    { label: "Guest Name", key: "name" },
    { label: "Checkin", key: "in" },
    { label: "Checkout", key: "out" },
    { label: "Mode", key: "mode" },
    { label: "Notes", key: "notes" },
  ];

  //XLSX
  const handleExportXlsx = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dataTable);

    XLSX.utils.book_append_sheet(wb, ws, "MySheet1");

    XLSX.writeFile(wb, "CheckinGuest.xlsx");
  };

  useEffect(() => {
    getData();
    autoDelete();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.reverse().slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, getSuccess, modalShow, successEditModalPrice]);

  const handleEditPrice = async()=>{
    try {      
      if (idForPrice) {      
        await axios.put(`https://mobile.amospa.com/checkin/${idForPrice}`, {
          price: price,
        });
        setShowModalPrice(false)
        setSuccessEditShowModalPrice(true)
      }
    } catch (error) {
      console.log('err', error.message);
    }
  }

  const handleEditKey = async()=>{
    try {      
      if (idForPrice) {      
        await axios.put(`https://mobile.amospa.com/checkin/${idForPrice}`, {
          key: key,
        });
        setShowModalKey(false)
        setSuccessEditShowModalPrice(true)
      }
    } catch (error) {
      console.log('err', error.message);
    }
  }


  return (
    <div className="chekin">
      <div className="chekin-header pt-2 m-0">
        <div className="sum-chekin">
          <h3 className="text-white">
            Total Guest:{" "}
            <span style={{ color: "#FFD700" }}>{data && data.length}</span>
          </h3>
          <h3 className="text-white">
            InHouse:{" "}
            <span style={{ color: "#FFD700" }}>
              {aktifGuest && aktifGuest.length}
            </span>
          </h3>
        </div>
        <div className="chekin-refresh">
          <button
            className="btn-chekin-refresh bg-success text-white fw-bold p-2"
            onClick={() => window.location.reload()}
          >
            <img src={refreshIcon} alt="" /> Refresh
          </button>
        </div>
      </div>
      <div className="chekin-list-header">
        <span className="d-flex align-items-center">
          <h3 className="text-white ms-3 me-2 ">List Guest Today</h3>
          <p>
            <select onChange={(e) => setitemsPerPage(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>{" "}
          </p>
        </span>

        <span className="d-flex">
          <button
            onClick={handleExportXlsx}
            className="btn text-decoration me-1 fw-bold"
            style={{
              background: "#FFD700",
              color: "black",
              outline: "none",
            }}
          >
            XLSX
          </button>
          <CSVLink
            data={dataTable}
            headers={headers}
            filename="Checkin Guest"
            className="btn  text-decoration-none me-1 fw-bold"
            separator={";"}
            style={{ background: "#FFD700", color: "black" }}
          >
            CSV
          </CSVLink>
          <ReactToPrint
            trigger={() => {
              return (
                <button
                  className="btn text-decoration me-1 fw-bold"
                  style={{ background: "#FFD700", color: "black" }}
                >
                  PRINT
                </button>
              );
            }}
            content={() => componentRef}
            documentTitle="new document"
            pageStyle="print"
            className="bg-success"
          />
          {/* <Link to={"/homepage/members/add-chekin"}>
            <button
              className="btn rounded-3 me-2 fw-bold"
              style={{ background: "#FFD700" }}
            >
              ADD GUEST
            </button>
          </Link> */}
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoComplete}
            />
          </span>
        </span>
      </div>
      <Table striped bordered hover ref={(el) => (componentRef = el)}>
        <thead>
          <tr>
            <th>NO</th>
            <th>Guest Name</th>
            <th>Checkin</th>
            <th>Checkout</th>
            <th>Status</th>
            <th>Key</th>
            <th>Notes</th>
            <th>F_B Notes</th>
            <th>Action Edit</th>
          </tr>
        </thead>
        <tbody>
          {dataTable?.map((item, index) => {
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.name}</td>
                <td>
                  {dateFormat(new Date(item.in), "d-mmmm-yyyy, HH:MM:ss")}
                </td>
                <td>
                  {item.out ? (
                    dateFormat(new Date(item.out), "d-mmmm-yyyy, HH:MM:ss")
                  ) : (
                    <span>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => handleCheckout(item.id)}
                        style={{ borderRadius: "10px" }}
                      >
                        Checkout
                      </button>
                      <span className="ms-1 text-secondary">
                        {moment(new Date(item.in), "YYYYMMDD").fromNow()}
                      </span>
                    </span>
                  )}
                </td>
                <td>{item.mode}</td>
                <td>{item.key}</td>
                <td>{item.notes}</td>
                <td>{item?.price}</td>
                <td>
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={()=>{setShowModalPrice(true)
                      setIdForPrice(item.id)}}
                      style={{ borderRadius: "10px" }}
                    >
                      <ImSpoonKnife color="white" size={20} />
                    </button>

                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={()=>{setShowModalKey(true)
                      setIdForPrice(item.id)}}
                      style={{ borderRadius: "10px", marginLeft:'10px' }}
                    >
                      <Icon.Key color="white" size={20} />
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <div className="footer-member-list my-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-member-list-rigth me-1">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Checkout Success"
        nextButton={handleNext}
      />

    <SweetAlert 
    title="Edit F&B Price Column" 
    show={showModalPrice}
    // onConfirm={handleEditPrice} 
    onCancel={()=>setShowModalPrice(false)} 
    customButtons={
      <React.Fragment>
        <Button variant="danger" style={{marginRight:'10px'}} onClick={()=>setShowModalPrice(false)}>Cancel</Button>
        <Button variant="warning" onClick={()=>handleEditPrice()}>OK</Button>
      </React.Fragment>
    }
    >
      <span className='wrapper-input-price-fdanb'>
        <input style={{width:'100%', height:'35px', borderRadius:'6px', outline:'none', 
          border:'1px solid gray', paddingLeft:'6px'}}
          placeholder='TYPE TO EDIT . . . .' type={'text'}
          onChange={(e)=>setPrice(e.target.value)}/>
      </span>
    </SweetAlert>

    <SweetAlert 
    title="Edit KEY Column" 
    show={showModalKey}
    // onConfirm={handleEditPrice} 
    onCancel={()=>setShowModalKey(false)} 
    customButtons={
      <React.Fragment>
        <Button variant="danger" style={{marginRight:'10px'}} onClick={()=>setShowModalKey(false)}>Cancel</Button>
        <Button variant="warning" onClick={()=>handleEditKey()}>OK</Button>
      </React.Fragment>
    }
    >
      <span className='wrapper-input-price-fdanb'>
        <input style={{width:'100%', height:'35px', borderRadius:'6px', outline:'none', 
          border:'1px solid gray', paddingLeft:'6px'}}
          placeholder='TYPE TO EDIT . . . .' type={'text'}
          onChange={(e)=>setKey(e.target.value)}/>
      </span>
    </SweetAlert>

    <SweetAlert
      success
      title="Success"
      // onConfirm={()=>setSuccessEditShowModalPrice(false)}
      onCancel={()=>setSuccessEditShowModalPrice(true)}
      show={successEditModalPrice}
      customButtons={
        <React.Fragment>
          <Button variant="warning" style={{width:'100px', height:'40px', fontWeight:'bold'}}
          onClick={()=>{setSuccessEditShowModalPrice(false)}}>OK</Button>
        </React.Fragment>
      }
    >
      <h5>Edit Success</h5>
    </SweetAlert>
    </div>
  );
}

export default Chekin;
